import { Component, SimpleChanges, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MessageService } from 'base';
import { MonitorService } from 'monitor';
import { IdentityService } from 'identity';
import { MonitorEditorComponentBase } from '../../MonitorEditorComponentBase';
import { PrtgSettings2Component } from '../prtgsettings2/prtgsettings2.component';
import { MonitorScheduleComponent } from '../../monitorschedule/monitorschedule.component';
import { NavigationService } from 'netview';
import { Schedule } from 'DiscoveryEngine.TS/Utils';

@Component({
	selector: 'prtg-monitor',
	templateUrl: './prtgmonitor.component.html',
	styleUrls: ['./prtgmonitor.component.scss']
})
export class PrtgMonitorComponent extends MonitorEditorComponentBase {

	@ViewChild(PrtgSettings2Component, { static: true })
	public prtgSetsComponent: PrtgSettings2Component;

	@ViewChild(MonitorScheduleComponent, { static: true })
	public monSchedComponent: MonitorScheduleComponent;

	constructor(monitorService: MonitorService,
		messageService: MessageService,
		identityService: IdentityService,
		navService: NavigationService,
		changeDetector: ChangeDetectorRef) {

		super(monitorService, messageService, identityService, navService, changeDetector);
	}

	public ngOnInit(): void {
		super.ngOnInit();

		this.children = [
			this.prtgSetsComponent,
			this.monSchedComponent,
		];
	}

	public ngOnChanges(changes: SimpleChanges): void {
		super.ngOnChanges(changes);
	}

	public ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	public get schedule(): Schedule {
		if (this.monSchedComponent)
			return this.monSchedComponent.value;
		else
			return new Schedule();
	}

}
